import { useTranslation } from 'react-i18next';

import { Button } from '@brightlocal/ui-components/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@brightlocal/ui-components/card';
import { TypographyText } from '@brightlocal/ui-components/typography-text';

interface Props {
  /** The title of the error page */
  title: string;
  /** The description (e.g. "404 Error") shown below the title */
  description: string;
  /** The body content of the error page */
  content: string;
  /** Callback invoked when the "Contact support" button is clicked */
  onContactSupport: VoidFunction;
  /** Callback invoked when the "Back to All Locations" button is clicked */
  onGoHome: VoidFunction;
}

export const LeftSide = ({ title, description, content, onContactSupport, onGoHome }: Props) => {
  const { t } = useTranslation();

  return (
    <Card className="max-w-100" dataHook="error-card" variant="transparent-flush">
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent className="whitespace-pre-line">
        <TypographyText dataHook="error-content">{content}</TypographyText>
      </CardContent>
      <CardFooter className="gap-6">
        <Button dataHook="contact-support-button" type="button" variant="outline" onClick={onContactSupport}>
          {t('errors.actions.contactSupport')}
        </Button>
        <Button dataHook="back-to-home-button" type="button" onClick={onGoHome}>
          {t('errors.actions.goToAllLocations')}
        </Button>
      </CardFooter>
    </Card>
  );
};
